'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLoadC = function IoLoadC(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 17.7c0 0.2 0 0.4-0.1 0.7-0.3 0.6-1.1 0.9-1.8 0.5-0.3-0.2-0.4-0.5-0.5-0.9-0.1-0.3-0.1-0.7-0.2-1-0.3-1.6-0.9-3.2-1.7-4.6-0.9-1.6-2.2-3.2-3.7-4.4-1.4-1.1-3.1-2-4.8-2.5-1.7-0.5-3.3-0.7-5-0.7h-0.3c-0.3 0-0.5 0-0.7 0-0.5 0-1.1 0.1-1.6 0.2-1 0.2-1.9 0.5-2.9 0.9-1.6 0.6-3.1 1.5-4.4 2.7s-2.5 2.6-3.3 4.1c-1 1.7-1.6 3.5-1.9 5.4-0.1 0.9-0.1 1.8-0.1 2.7 0 0.4 0 0.8 0 1.2 0.1 0.5 0.2 1 0.3 1.5 0.4 1.9 1.1 3.7 2.2 5.2 1 1.6 2.2 3 3.7 4.1 1.6 1.2 3.3 2 5.1 2.6 1.9 0.5 3.9 0.7 5.9 0.5 2-0.1 3.9-0.7 5.7-1.5 0.9-0.4 1.7-1 2.5-1.5s1.5-1.2 2.1-1.9c0.3-0.3 0.7-0.7 1-1.1s0.5-0.8 0.8-1.2 0.9-1.5 1.3-2.4c0.3-0.6 0.6-1.2 0.8-1.9 0.2-0.3 0.3-0.7 0.4-1s0-0.6 0.1-0.9c0.1 0.7 0.1 1.4-0.1 2 0 0.4-0.1 0.9-0.3 1.3-0.1 0.4-0.2 0.8-0.4 1.2-0.3 0.7-0.6 1.4-1 2.1-0.5 0.9-0.9 1.7-1.6 2.4s-1.2 1.4-1.9 2c-1.4 1.2-3.1 2.1-4.9 2.8-1.7 0.7-3.7 1.1-5.7 1.2s-3.9-0.2-5.8-0.9c-1.8-0.5-3.5-1.4-5.1-2.5-1.5-1.1-2.8-2.5-3.9-3.9-0.5-0.8-1-1.6-1.4-2.5s-0.7-1.6-1-2.5c-0.5-1.4-0.7-2.9-0.8-4.4-0.1-1.6 0.1-3.1 0.4-4.5 0.4-1.9 1.2-3.7 2.2-5.4 0.9-1.4 2-2.7 3.3-3.9s2.7-2.1 4.3-2.8c1.8-0.8 3.7-1.5 5.7-1.6 0.8-0.1 1.5-0.1 2.3-0.1 1 0 2 0.2 3 0.3 1.8 0.4 3.6 1.1 5.3 2s3.2 2.3 4.4 3.8c1.2 1.4 2.1 2.9 2.8 4.5 0.4 0.8 0.6 1.7 0.8 2.5 0.2 0.6 0.4 1.4 0.5 2.1z' })
        )
    );
};

exports.default = IoLoadC;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/load-c.js
// module id = 2819
// module chunks = 168707334958949